import { useEffect, useState, useContext } from 'react';
import '../../App.scss';
import '../../css/forms.scss';
import BaseContainer from '../../components/Container';
import TabHeader from '../../components/TabHeader';
import BaseForm from '../../components/BaseForm';
import { serverFetch, serverPatch } from '../../helpers/server';
import { BaseContext } from '../../helpers/common';
import { useSearchParams } from "react-router-dom";
import { getTabItems } from '../../helpers/tabs'
import { Alert, Row, Col, Table } from 'react-bootstrap';
import Notification from '../../components/Notification';
import { useTranslation } from 'react-i18next';
const _ = require("lodash");

function BlockVenue() {
    const { getApiUrl, facilityLink, getFacilityName } = useContext(BaseContext);
    const [loading, setLoading] = useState(true);
    const [venues, setVenues] = useState([]);
    const [venueDetails, setVenueDetails] = useState({});
    const [ searchParams ] = useSearchParams();
    const venueId = searchParams.get('id');
    const { t } = useTranslation('common');

    useEffect(() => {
        document.title = `${venueDetails.name} (Block Sync) - ${getFacilityName()}`;
    }, [venueDetails]);

    useEffect(() => {
        setLoading(true);
        serverFetch(getApiUrl(`/venues/${venueId}`)).then((res) => {
            setVenueDetails(res);
            setLoading(false);
        });

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [venueId]);

    const fetchData = (skipCache=false) => {
        serverFetch(getApiUrl(`/venues/${venueId}/block_sync`), { skipCache }).then((res) => {
            setVenues(_.filter(res, (r) => String(r.venueId) !== String(venueId)));
        });
    }

    const updateChecked = (event) => {
        const targetVenueId = event.target.value;
        const isChecked = event.target.checked;
        const data = {
            venueId: targetVenueId,
            selected: isChecked
        }
        serverPatch(getApiUrl(`/venues/${venueId}/block_sync`), data, {}).then((res) => {
            if (res) {
                Notification.Show(t('notification.successfully_updated'));
            }
            fetchData(true);
        });
    }

    const updateColor = (newColor) => {
        const data = {
            blockColor: newColor
        };
        serverPatch(getApiUrl(`/venues/${venueId}/settings`), data, {}).then((res) => {
            if (res) {
                Notification.Show(t('notification.successfully_updated'));
            }
        });
    }

    const tabsParams = {
        searchParams: venueId && `id=${venueId}`,
        venueName: venueDetails.name
    };
    return (
        <BaseContainer>
            <TabHeader items={getTabItems(t, facilityLink, "venue-settings", tabsParams)}/>
            <div className="content-box">
                <div className="content-body">
                    <Alert variant="info">
                        <strong>{t("setting.block_sync.title")}:</strong> {t("setting.block_sync.desc")}
                    </Alert>
                    {
                        !loading &&
                            <>
                                <Row>
                                    <Col md="3">
                                        <BaseForm
                                            initialFormFields={{ blockColor: venueDetails.blockColor || "#6d8bbf"}}
                                            onFieldChange={(name, value) => updateColor(value)}
                                        >
                                            <BaseForm.Input name="blockColor" type="color" label={t("setting.block_sync.color")} />
                                        </BaseForm>
                                    </Col>
                                </Row>
                                <br/>
                                <Row>
                                    <Col md="6">
                                        <Table hover>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>{t("setting.venue_name")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    _.map(venues, (venue, i) =>
                                                        <tr key={i}>
                                                            <td>
                                                                <div className="checkbox check-success inline">
                                                                    <input type="checkbox" className="" value={venue.venueId} id={venue.venueId} name="sync[]" checked={venue.selected} onChange={ (event) => updateChecked(event) }/>
                                                                    <label htmlFor={venue.venueId}/>
                                                                </div>
                                                            </td>
                                                            <td>{venue.venueName}</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </>
                    }
                </div>
            </div>
        </BaseContainer>
    );
}

export default BlockVenue;
